<script lang="ts" setup>
const { createCondition } = useSegmentation()

const query = ref<SegmentationCondition[]>([
  createCondition({
    attribute: 'about.industries',
    blockedOperator: false,
    operator: 'or',
    sign: 'equals',
    values: [
      'retail',
      'internet',
      'services',
    ],
  }),
])
</script>

<template>
  <SegmentationVertical
    v-model="query"
    endpoint="/companies"
    feature="search"
    has-borders
    has-query-preview
  />
</template>
